// import store from '@/store/index.js'
// let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "姓名",
            span: 8,
            placeholder: '请输入姓名',
            model: "studentName"
        },
        {
            label: "学号",
            span: 8,
            placeholder: '请输入学号',
            model: "studentNo"
        },
        {
            label: "完成情况",
            span: 8,
            placeholder: '请选择',
            model: "status",
            options: [
                { label: '未完成', value: 0 },
                { label: '已完成', value: 1 },
            ]
        },
    ]
    const tableColumns = [
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true
        },
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 260,
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "完成情况",
            prop: "statusName",
            align: "center",
            show: true,
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "姓名",
            span: 24,
            model: "studentName",
            placeholder: '请输入站点名称',
            labelClass: 'info-label',
        },
        {
            label: "学号",
            span: 24,
            model: "studentNo",
            labelClass: 'info-label',
            placeholder: '请输入说明',
        },
				{
				    label: "学院",
				    span: 24,
				    model: "collegeName",
				    labelClass: 'info-label',
				    placeholder: '请输入说明',
				},
				{
				    label: "专业",
				    span: 24,
				    model: "majorName",
				    labelClass: 'info-label',
				    placeholder: '请输入说明',
				},
				{
				    label: "班级",
				    span: 24,
				    model: "className",
				    labelClass: 'info-label',
				    placeholder: '请输入说明',
				},
				{
				    label: "完成情况",
				    span: 24,
				    model: "description",
				    labelClass: 'info-label',
				    placeholder: '请输入说明',
				},
    ]

    const formRules = {
        location: [{
            required: true,
            trigger: "blur",
            message: '请输入站点名称'
        }],
        description: [{
            required: true,
            trigger: "blur",
            message: '请输入说明'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
